import { Stack } from "@mui/material";
import { ITouchpoint } from "../../../../types";
import dayjs from "dayjs";
import { InsightsItem } from "./InsightsItem";


export const InsightsList = ({ section, touchpoints }: { section: string, touchpoints: ITouchpoint[] }) => {

    return (
        <Stack direction="column" gap={3} mb={4}>

            {touchpoints.sort((a: any, b: any) => {
                return new Date(b.scheduled_at).getTime() - new Date(a.scheduled_at).getTime();
            }).map((touchpoint: any) => (
                <InsightsItem key={touchpoint.uuid} touchpoint={touchpoint} />
            ))}

        </Stack>
    )
}